export const filterColumnClassName = 'filter-header border bg-gray-100';
export const filterCellClass = 'border';
export const filterClassname = 'input-form-text';
export const dataGridClassname = 'h-[77.2vh] border-separate border-spacing-2 border shadow-lg rounded-lg';
export const dataGridTabClassname = 'h-[70.1vh] border-separate border-spacing-2 border shadow-lg rounded-lg';
export const styleDataGrid = `
.filter-header {
  line-height: 42px;
  padding: 5;
  > div {
    padding: 0 8px;
    &:first-child {
      border-bottom: 1px solid var(--border-color);
    }
  }
}
.loading-renderer {
  margin-top: -75px;
}
`;


export function inputStopPropagation(event: React.KeyboardEvent<HTMLInputElement>) {
  if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {
    event.stopPropagation();
  }
}

export function selectStopPropagation(event: React.KeyboardEvent<HTMLSelectElement>) {
  if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
    event.stopPropagation();
  }
}

export interface SummaryRow {
  id: string;
  totalCount: number;
}

type Comparator = (a: any, b: any) => number;
export function getComparator(sortColumn: string): Comparator {
  if(sortColumn){
    return (a, b) => {
      const aValue = a[sortColumn] ?? -1;
      const bValue = b[sortColumn] ?? -1;

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return aValue.localeCompare(bValue);
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return aValue - bValue;
      }

      return 0;
    }
  }
  throw new Error(`unsupported sortColumn: "${sortColumn}"`)
}